<script setup lang="ts">


const htmlClass = 'dark'


</script>
<template>
  <Html :class="htmlClass">
    <Body class="bg-gray-800">
    <NuxtLayout>
       <NuxtPage class="overflow-x-hidden bg-gray-800"/>
    </NuxtLayout>
    </Body>
  </Html>
</template>
